//
// Copyright (C) 2014 - present Instructure, Inc.
//
// This file is part of Canvas.
//
// Canvas is free software: you can redistribute it and/or modify it under
// the terms of the GNU Affero General Public License as published by the Free
// Software Foundation, version 3 of the License.
//
// Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
// WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
// A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
// details.
//
// You should have received a copy of the GNU Affero General Public License along
// with this program. If not, see <http://www.gnu.org/licenses/>.

import $ from 'jquery'
import getCookie from 'jsx/shared/helpers/getCookie'

const authenticity_token = () => getCookie('_csrf_token')

$(document).on('submit', 'form', function() {
  $(this)
    .find('input[name="authenticity_token"]')
    .val(authenticity_token())
})

// return a function to be used elsewhere
export default authenticity_token
